import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {CustomerNotification} from '../types/CustomerNotification';

export const useGetCustomerNotifications = (retailOrderID: number, enabled: boolean) => {

    const { data, isLoading } = useQuery({
        queryKey: ['customer-notifications', retailOrderID],
        queryFn: async () => await apiClient.get('retail-order/customer-notifications',
            { params: { retailOrderID: retailOrderID } }) as CustomerNotification[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
